import { useEffect, useState } from "react";

import { subscribeMeetingActive, type Client, type MeetingPresence } from "~/lib/matrix";

export function useMeetingActive(
  client: Client | null,
  roomId: string | null,
): MeetingPresence | null {
  const [meeting, setMeeting] = useState<MeetingPresence | null>(null);
  useEffect(() => {
    if (!client || !roomId) {
      setMeeting(null);
      return;
    }
    return subscribeMeetingActive(client, roomId, setMeeting);
  }, [client, roomId]);
  return meeting;
}
